import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import logo from "@/assets/logo.png";

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { href: "#about", label: "About" },
    { href: "#venue", label: "Venue" },
    { href: "#menus", label: "Menus" },
    { href: "#testimonials", label: "Testimonials" },
    { href: "#tour", label: "Schedule Tour" },
    { href: "#contact", label: "Contact" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? "bg-card/95 backdrop-blur-md shadow-soft py-2"
          : "bg-transparent py-4"
      }`}
    >
      <div className="container-elegant flex items-center justify-between px-4">
        <a href="#" className="flex items-center gap-3 ml-2 md:ml-12 mt-2">
          <img
            src={logo}
            alt="Gracious Gatherings Catering"
            className={`transition-all duration-300 rounded-full ${
              isScrolled ? "h-10 w-10 md:h-32 md:w-32" : "h-12 w-12 md:h-56 md:w-56"
            }`}
            style={{ background: 'transparent' }}
          />
        </a>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`font-bold transition-colors duration-300 hover:text-accent ${
                isScrolled ? "text-foreground" : "text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.5)]"
              }`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#booking"
            className="btn-gold px-6 py-2.5 rounded-full text-sm font-semibold hover:opacity-90 transition-opacity"
          >
            Book Now
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="md:hidden p-2"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? <X size={24} className={isScrolled ? "text-foreground" : "text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.5)]"} /> : <Menu size={24} className={isScrolled ? "text-foreground" : "text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.5)]"} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-card/98 backdrop-blur-md shadow-elevated animate-fade-in">
          <div className="flex flex-col p-6 gap-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-foreground font-medium py-2 hover:text-accent transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#booking"
              onClick={() => setIsMobileMenuOpen(false)}
              className="btn-gold px-6 py-3 rounded-full text-center font-semibold mt-2"
            >
              Book Now
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
